import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { toast } from 'react-toastify';
import { StaffType } from '../../common/constants';
import Loading from '../../components/global/OverLoading';
import ApiService from '../../services.js/apiService';

function StaffTable(props) {
  const [currentStaffList, setCurrentStaffList] = useState([]);
  const [loading, setIsLoading] = useState(false);

  const fetchStaff = async () => {
    setIsLoading(true);
    await ApiService.getBusinessStaff({ pageId: props.pageId })
      .then((data) => {
        setCurrentStaffList(data);
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="p-2">
        <MaterialTable
          title=""
          isLoading={loading}
          columns={[
            { title: 'Email', field: 'inviteEmail', editable: 'never' },
            {
              title:  'Staff Type',
              field:  'type',
              lookup: {
                Contributor: StaffType.Contributor,
                Observer:    StaffType.Observer,
                Admin:       StaffType.Admin,
              },
            },
            {
              title:    'Invite Status',
              field:    'inviteStatus',
              editable: 'never',
            },

          ]}
          data={currentStaffList}
          actions={[]}
          options={{
            actionsColumnIndex: -1,
            filtering:          true,
          }}
        />
      </div>
    </>
  );
}

StaffTable.defaultProps = {
  //isLoading: false,
};

StaffTable.propTypes = {
  pageId: PropTypes.number.isRequired,
};

export default StaffTable;
